module.exports = __webpack_public_path__ + "img/downbg.41da74bb.png";